// data-page 判定とページ別JSの遅延読み込み
const pageLoaders = {
  'ai-analysis': () => import('./ai-analysis'),
  'ai-cost-report': () => import('./ai-cost-report'),
  'ai-search': () => import('./ai-search'),
  'ai-structured-search': () => import('./ai-structured-search'),
  'bulk-imports': () => import('./bulk-imports'),
  'box-oauth-callback': () => import('./box-oauth-callback'),
  'cloudstorage-settings-guide': () => import('./cloudstorage-settings-guide'),
  'cloudstorage-settings': () => import('./cloudstorage-settings'),
  'desktop-app-guide': () => import('./desktop-app-guide'),
  'desktop-tokens': () => import('./desktop-tokens'),
  'dropbox-oauth-callback': () => import('./dropbox-oauth-callback'),
  'folder-form': () => import('./folder-form'),
  'folder-permissions': () => import('./folder-permissions'),
  'logo-settings': () => import('./logo-settings'),
  'logs': () => import('./logs'),
  'logs-share': () => import('./logs-share'),
  'my-reports': () => import('./reports'),
  'reports': () => import('./reports'),
  'share-bundle': () => import('./share-bundle'),
  'share-download': () => import('./share-download'),
  'share-upload': () => import('./share-upload'),
  'two-factor-auth': () => import('./two-factor-auth'),
  'user-form': () => import('./user-form'),
  'users-index': () => import('./users-index'),
  'video-form': () => import('./video-form'),
};

const resolvePageKey = () => {
  const pageElement = document.querySelector('[data-page]');
  const pageKey = pageElement?.dataset?.page;
  if (pageKey) {
    return pageKey;
  }

  if (document.getElementById('share-download-form')) {
    return 'share-download';
  }

  return null;
};

export const bootPageModules = () => {
  const pageKey = resolvePageKey();
  if (!pageKey) {
    return;
  }

  const loader = pageLoaders[pageKey];
  if (!loader) {
    return;
  }

  loader()
    .then((module) => {
      if (typeof module?.default === 'function') {
        module.default();
      }
    })
    .catch((error) => {
      console.error(`[page-loader] Failed to load "${pageKey}" module`, error);
    });
};
